import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';

const topics = [
  { question: 'What is Smart Money Concepts (SMC)?', icon: '💡' },
  { question: 'What are liquidity grabs in SMC?', icon: '💧' },
  { question: 'What is an order block?', icon: '📦' },
  { question: 'What are breaker blocks?', icon: '🔄' },
  { question: 'What is a fair value gap (FVG)?', icon: '⚖️' },
  { question: 'What is market structure?', icon: '🏗️' },
  { question: 'What is internal vs external structure?', icon: '🧩' },
  { question: 'What is inducement in SMC?', icon: '🎯' },
  { question: 'What is displacement in price action?', icon: '💨' },
  { question: 'What is imbalance in the market?', icon: '⚡' },
  { question: 'What is premium vs discount pricing?', icon: '💲' },
  { question: 'What are liquidity pools?', icon: '🏊' },
  { question: 'What is stop hunt liquidity?', icon: '🔍' },
  { question: 'What is the role of institutional order flow?', icon: '🏦' },
  { question: 'What is a mitigation block?', icon: '🛡️' },
  { question: 'What is the difference between supply and demand zones?', icon: '📊' },
  { question: 'How to identify strong vs weak highs?', icon: '📈' },
  { question: 'How to identify strong vs weak lows?', icon: '📉' },
  { question: 'What is a BOS (Break of Structure)?', icon: '🔓' },
  { question: 'What is a CHoCH (Change of Character)?', icon: '🔄' },
  { question: 'What is market manipulation in SMC?', icon: '🎭' },
  { question: 'How to read liquidity sweeps?', icon: '🌊' },
  { question: 'What is equal highs and equal lows?', icon: '⚖️' },
  { question: 'How to confirm an order block?', icon: '✅' },
  { question: 'What is inefficiency in price?', icon: '📉📈' },
  { question: 'What is the difference between FVG and imbalance?', icon: '⚡🔍' },
  { question: 'What is smart money reversal?', icon: '↩️' },
  { question: 'What is continuation order flow?', icon: '➡️' },
  { question: 'What are liquidity voids?', icon: '🕳️' },
  { question: 'What is an institutional candle?', icon: '🕯️' },
  { question: 'What are market maker models?', icon: '🎲' },
  { question: 'What is accumulation in SMC?', icon: '📥' },
  { question: 'What is distribution in SMC?', icon: '📤' },
  { question: 'What are the 3 phases of market structure?', icon: '3️⃣' },
  { question: 'What is the difference between inducement and liquidity grab?', icon: '🤔' },
  { question: 'How to identify premium vs discount zones?', icon: '📏' },
  { question: 'What is a pro trend order block?', icon: '📦📈' },
  { question: 'What is a counter trend order block?', icon: '📦📉' },
  { question: 'What is the relationship between SMC and Wyckoff?', icon: '🔗' },
  { question: 'How to use Fibonacci retracement with SMC?', icon: '📐' },
  { question: 'What is the significance of timeframes in SMC?', icon: '⏱️' },
  { question: 'How to combine ICT concepts with SMC?', icon: '🧠' },
  { question: 'What is a liquidity run?', icon: '🏃' },
  { question: 'How to identify manipulation candles?', icon: '🕯️🔍' },
  { question: 'What is the purpose of a mitigation move?', icon: '♻️' },
  { question: 'What is the difference between BOS and CHoCH?', icon: '⚔️' },
  { question: 'How to spot liquidity before news events?', icon: '📰' },
  { question: 'What is an order block refinement?', icon: '🔧' },
  { question: 'How to trade fair value gaps effectively?', icon: '🎯' },
];

const AskChartTopicsLessons = () => {
  const [showUpgrade, setShowUpgrade] = useState(false);

  const handleTopicClick = () => {
    setShowUpgrade(true);
  };

  const closeUpgrade = () => {
    setShowUpgrade(false);
  };

  return (
    <div style={{ marginTop: '30px', maxWidth: '960px', width: '100%' }}>
      {/* <h5 style={{ color: '#FF7C24', fontWeight: 'bold', marginBottom: '12px' }}>
        Learn while Looking
      </h5> */}
      {/* <p style={{ color: '#232830', fontSize: '14px', marginBottom: '20px', backgroundColor: '#fbe9e0', padding: '10px 12px', borderRadius: '8px' }}>
        Start Free Trial
      </p> */}
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px' }}>
        {topics.map((topic, index) => (
          <div
            key={index}
            onClick={handleTopicClick}
            style={{
              flex: '0 1 calc(50% - 8px)',
              backgroundColor: '#ffffff',
              borderRadius: '16px',
              padding: '16px',
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              transition: 'transform 0.2s ease',
            }}
            onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.02)')}
            onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
          >
            <span style={{ fontSize: '22px' }}>{topic.icon}</span>
            <span style={{ fontSize: '15px', fontWeight: '600', color: '#232830' }}>{topic.question}</span>
          </div>
        ))}
      </div>

      <Modal show={showUpgrade} onHide={closeUpgrade} centered>
        <Modal.Header closeButton>
          <Modal.Title style={{ color: '#FF7C24', fontWeight: 'bold' }}>
            🚀 You’ve used up the free limit.
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ textAlign: 'center' }}>
          <p style={{ fontWeight: 'bold', fontSize: '16px', color: '#232830' }}>
            Upgrade to FinTorro Pro and get:
          </p>
          <ul className="list-unstyled" style={{ fontSize: '15px', lineHeight: '1.6', color: '#232830', textAlign: 'left' }}>
            <li>• Unlimited Lessons & Practice</li>
            <li>• Learn with AI</li>
            <li>• 10,000+ Interactive Lessons</li>
            <li>• Crypto, Forex, Stocks & More</li>
            <li>• Join Challenges & Earn Rewards</li>
          </ul>
        </Modal.Body>
        <Modal.Footer style={{ justifyContent: 'center' }}>
          <Button
            variant="warning"
            style={{
              backgroundColor: '#FF7C24',
              border: 'none',
              fontWeight: 'bold',
              borderRadius: '12px',
              padding: '10px 20px',
            }}
            onClick={() => window.open('https://buy.stripe.com/eVa29y1Ig8zsgFycMZ')}
          >
            Upgrade to Pro
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AskChartTopicsLessons;
